<script>

import { onMount } from 'svelte';

var body;
var tblBody;

var serialization = "";
var msg = "";

const rows=50;
var cols=50;
var interval = 10;
var w = 33;
var h = 33;


function ccc(){
  /* "magic" controls whether the square changes color, or is of a fixed color. */
	console.log("click")
	const context = this.getContext('2d')
	context.magic = !context.magic;
	console.log(context.magic)
}
    
function generate_data() {
  var data = [];
  for (var j = 0; j < rows; j++) 
  {
    var row = [];
    data.push(row);
    for (var i = 0; i < cols; i++) 
    {
      var cell = {}
      row.push(cell)
      cell.cycle_count = 1;
      cell.cycle_counter = 255;
      if ((j == 5)&&(i == 5))
        cell.magic = true;
      else  
        cell.magic = false;
      cell.rgb = [255,255,255]
    }
  }
  return data;
}

function generate_table(data) {
  while (body.firstChild) {
    body.removeChild(body.firstChild);
  }
  var tbl = document.createElement("table");
  body.appendChild(tbl);
  tbl.style.borderSpacing = 0
  tbl.setAttribute("border", "0");
  tblBody = document.createElement("tbody");
  tbl.appendChild(tblBody);

  for (var j = 0; j < data.length; j++) {
    var row_data = data[j]
    var row = document.createElement("tr");
    tblBody.appendChild(row);

    for (var i = 0; i < row_data.length; i++) {
      var cell_data = row_data[i]
      var cell = document.createElement("td");
      row.appendChild(cell);
      var canvas = document.createElement("canvas");
      cell.appendChild(canvas)

      canvas.addEventListener('contextmenu', function(ev) {
        console.log(ev)
        ev.preventDefault();
        context = ev.target.getContext('2d')
        context.magic = 0
        context.fillStyle='rgb(255,255,255)';
        context.fillRect(0, 0, w, h);
        context.cycle_count = 1;
        context.cycle_counter = 255;
        context.LED_pwm = new Array(255,255,255);
        return false;
      }, false);
      
      cell.style.padding="0px"
      var context = canvas.getContext('2d');
      cell.height = h;
      cell.width = w;
      canvas.height = h
      canvas.width = w
      canvas.onclick = ccc;
      
      context.cycle_count = cell_data.cycle_count;
      context.cycle_counter = cell_data.cycle_counter;
      context.magic = cell_data.magic;
      context.LED_pwm = new Array(cell_data.rgb[0], cell_data.rgb[1], cell_data.rgb[2]);
      draw_cell(context);
    }
  }
}


function save()
{
  var rows_arr = [];
  for (var j = 0; j < rows; j++) {
    var row = []
    rows_arr.push(row)
    for (var i = 0; i < cols; i++) {
      var c = cell_by_pos(j,i);
      row.push({
        magic:c.magic,
        cycle_counter: c.cycle_counter,
        cycle_count: c.cycle_count,
        rgb: c.LED_pwm
      })
    }
  }
  //console.log(rows_arr)
  serialization = JSON.stringify(rows_arr);
}

function load()
{
  try{
    //console.log(serialization)
    generate_table(JSON.parse(serialization))
  }
  catch(err)
  {
    msg = err;
    return
  }
  msg = "";
}

function animate(banana)
{

switch (banana.cycle_count)
{

  case 1:
    var incColor = 1;
    var decColor = 0;
    var noColor = 2;
    break;
  case 2:
    var incColor = 2;
    var decColor = 1;
    var noColor = 0;
    break;
  case 3:
    var incColor = 0;
    var decColor = 2;
    var noColor = 1;
    break;
}

  if (banana.cycle_counter > 0){
    banana.cycle_counter--;
    banana.LED_pwm[decColor] -= 1;
    banana.LED_pwm[incColor] += 1;
    banana.LED_pwm[noColor] = 0;
  }
  else if (banana.cycle_counter == 0){
    banana.cycle_counter = 255;
    if (banana.cycle_count != 3){
      banana.cycle_count++;
    }

    else {
      banana.cycle_count = 1;
    }
  }
  
  draw_cell(banana);
}

function draw_cell(banana)
{
  banana.fillStyle='rgb(' + banana.LED_pwm[0]+','+banana.LED_pwm[1]+','+banana.LED_pwm[2]+')';
  const border = 2
  banana.fillRect(border,border,w-2*border,h-2*border);
}

function cell_by_pos(r,c)
{
  var tr = tblBody.children[r];
  var td = tr.children[c];
  return td.firstChild.getContext('2d');
}

function animate_table()
{
		//cycle thru all cells
	for (var j = 0; j < rows; j++)
  {
		for (var i = 0; i < cols; i++)
		{
			var c = cell_by_pos(j,i)
			if(c.magic)animate(c);
		}
  }
}


onMount(async () => {
  body = document.getElementById("body");
  await generate_table(generate_data());
  await window.setInterval(animate_table, interval);
})




</script>

<main>

  <button on:click={save}>Save >></button>
  <input bind:value={serialization}>
  <button on:click={load}>>> Load</button>
  <pre>{msg}</pre>
  <div id="body"/>

</main>
